var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 1.33203H6.00001C2.66668 1.33203 1.33334 2.66536 1.33334 5.9987V9.9987C1.33334 13.332 2.66668 14.6654 6.00001 14.6654H10C13.3333 14.6654 14.6667 13.332 14.6667 9.9987V8.66536",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6933 2.01155L5.44001 7.26488C5.24001 7.46488 5.04001 7.85822 5.00001 8.14488L4.71334 10.1515C4.60668 10.8782 5.12001 11.3849 5.84668 11.2849L7.85334 10.9982C8.13334 10.9582 8.52668 10.7582 8.73334 10.5582L13.9867 5.30488C14.8933 4.39822 15.32 3.34488 13.9867 2.01155C12.6533 0.678215 11.6 1.10488 10.6933 2.01155Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94 2.76562C10.3867 4.35896 11.6333 5.60562 13.2333 6.05896",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.938b3b58e226b5d2c926c2c6cd579520.svg";
export { ForwardRef as ReactComponent };